export default "__VITE_ASSET__0f4e1c36__"